// Shared week state for the three Ruteplaner views (Grafisk / Ukesvisning /
// Serieoversikt) so switching between them preserves the selected week.
export function mondayOf(d: Date) { const x = new Date(d); const day = (x.getDay() + 6) % 7; x.setDate(x.getDate() - day); return x; }
export function iso(d: Date) { return d.toISOString().slice(0, 10); }

// Timezone-safe local date string (YYYY-MM-DD). Unlike iso()/toISOString(), it
// never rolls a local Monday back to the previous Sunday in +TZ locales — the
// bug that desynced the Turnus week label from its columns. Shared by all
// turnus modules so the week helper is computed ONE way.
export function isoLocal(d: Date) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
export function addDays(d: Date, n: number) { const x = new Date(d); x.setDate(x.getDate() + n); return x; }

const KEY = 'routeplan-week-start';
function todayStr() { return isoLocal(new Date()); }

// Default the graphic/planning week to the CURRENT ISO week at OPENING, matching
// Bussplan/Turnus. A current/future week that was carried over is preserved. A
// PAST week is preserved only when it was chosen earlier TODAY (same-day history
// browsing across the three Ruteplaner views); a stale past week left over from
// an earlier day/session snaps FORWARD to the current week — never silently
// backwards. Manual back-navigation (the ‹ arrow) still works within a view.
export function getStoredWeekStart(): Date {
  const current = mondayOf(new Date());
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      let weekStr = raw; let savedAt = '';
      if (raw.charAt(0) === '{') { try { const o = JSON.parse(raw); weekStr = o.week || ''; savedAt = o.savedAt || ''; } catch { /* legacy plain value */ } }
      const d = new Date(String(weekStr).slice(0, 10) + 'T00:00:00');
      if (!isNaN(d.getTime())) {
        const stored = mondayOf(d);
        if (stored.getTime() >= current.getTime()) return stored;
        if (savedAt === todayStr()) return stored;
      }
    }
  } catch { /* noop */ }
  return current;
}

export function setStoredWeekStart(d: Date) {
  try { localStorage.setItem(KEY, JSON.stringify({ week: isoLocal(mondayOf(d)), savedAt: todayStr() })); } catch { /* noop */ }
}
